import React, { useMemo } from "react";
import _ from "lodash";
import styles from "./SelectObjectives.module.scss";
import { TextField, MenuItem, Checkbox, ListItemText, Typography, ListSubheader } from "@material-ui/core";
import PlanPill from "../PlanPill/PlanPill";
import { getYear, year } from "../../utils/dates";

const NewSelectObjectives = ({
  formik,
  name,
  objectives,
  categoryFilter,
  plansOrder = [],
  multiple = false,
  showEmpty = false,
  disabled = false,
  yearGrouped = false,
  helperText,
  handleSelect,
}) => {
  const { values: formikValues, errors, touched, getFieldProps } = formik;

  const objectiveOptions = useMemo(() => {
    if (_.isEmpty(objectives)) return [];

    let objs = _.sortBy(objectives, [
      function (obj) {
        // this preliminary sorting step is required if the list of objectives includes multiple plans
        return plansOrder.indexOf(_.get(obj, "plan.sharedPlanId"));
      },
      "number",
    ]);

    if (categoryFilter) {
      objs = _.filter(objs, ["category", categoryFilter]);
    }

    if (yearGrouped) {
      objs = _.groupBy(objs, (obj) => {
        return _.get(obj, "plan.year", _.get(obj, "year"));
      });
    }

    return objs;
  }, [objectives, plansOrder, categoryFilter, yearGrouped]);

  const renderObjectiveMenuItem = (obj) => {
    const { id, value, number, plan } = obj || {};
    return (
      <MenuItem key={id} value={id} className={styles.select}>
        <ListItemText>
          {!_.isNil(plan) ? <PlanPill plan={plan} /> : <PlanPill plan={null} />}
          {number}. {value}
        </ListItemText>
      </MenuItem>
    );
  };

  const isTouched = _.get(touched, name);
  const error = _.get(errors, name);

  const hasError = Boolean(isTouched && error);
  const helperTxt = hasError ? error : helperText;

  return (
    <TextField
      select
      fullWidth
      variant="outlined"
      margin="normal"
      label={`Tied In${categoryFilter ? ` ${_.startCase(categoryFilter)}` : ""} Objective${multiple ? "s" : ""}`}
      {...getFieldProps(name)}
      {...(handleSelect ? { onChange: (e) => handleSelect(e.target.value) } : {})}
      SelectProps={{
        multiple,
        ...(multiple
          ? {
              renderValue: (selected) => {
                return (
                  <Typography variant="inherit" noWrap>
                    {`${selected.length} Objective(s) Selected`}
                  </Typography>
                );
              },
            }
          : {}),
      }}
      InputLabelProps={{
        shrink: !_.isEmpty(_.get(formikValues, name)),
      }}
      error={hasError}
      helperText={helperTxt}
      disabled={disabled}
    >
      {showEmpty && (
        <MenuItem value={null} className={styles.select}>
          <ListItemText>No objective tie in</ListItemText>
        </MenuItem>
      )}
      {_.isArray(objectiveOptions)
        ? objectiveOptions.map((obj) => {
            return renderObjectiveMenuItem(obj);
          })
        : yearGrouped &&
          Object.keys(objectiveOptions)
            .sort((a, b) => b - a)
            .map((year) => {
              const objArr = _.get(objectiveOptions, year);
              return [
                <ListSubheader style={{ position: "relative" }}>{getYear(year)}</ListSubheader>,
                ...objArr.map((obj) => {
                  return renderObjectiveMenuItem(obj);
                }),
              ];
            })}
    </TextField>
  );
};

export default NewSelectObjectives;
